import React, { useEffect } from 'react';
import { useState } from 'react';
import { Button, ButtonGroup, FormControl, FormControlLabel, Grid, Input, InputLabel, Radio, RadioGroup } from '@material-ui/core';

import { useContext } from 'react';
import AppContext from '../../../../../App/AppContext';
import ArrivalDateModal from './statusModals/arrivalDate';
import RebookingRequiredModal from './statusModals/rebookingReq';
import CommonStatusModal from './statusModals/commonStatus';
import OtherStatusModal from './statusModals/otherStatusModal';

const BookedStatusModal = (props) => {
    const [state, setState] = useState({
        messaegList: [],
        actionLog: false,
        editActionLog: false,
        selectedStatus: +props.tCardStatusID || +props.statusList[0].id,
        smsText: '',
        sendSMSUpdate: false,
        statusList: [
            {
                id: 3,
                name: 'Vehicle Arrived'
            },
            {
                id: 2,
                name: 'Cancel Booking'
            }
        ],
        errors: {}
    });

    const [statusList, setStatusList] = useState({});

    useEffect(async () => {
        if (state.selectedStatus) {
            let tempMessage = props.statusList.find((q) => q.id == state.selectedStatus);
            setStatusList(tempMessage);
            if (tempMessage) {
                setState((st) => ({ ...st, smsText: tempMessage.smsText, sendSMSUpdate: tempMessage.sendSMSUpdate }));
            }
        }
    }, [state.selectedStatus]);

    const handleInput = (e) => {
        const { name, value, type, checked } = e.target;
        if (name === 'selectedStatus') {
            setState((st) => ({ ...st, [name]: value, dateArrived: '', rebookingDate: '' }));
        } else {
            setState((st) => ({ ...st, [name]: value }));
        }
    };

    return (
        <div>
            <Grid container spacing={1}>
                <Grid item row xs={12}>
                    <InputLabel shrink>New Status</InputLabel>

                    <ButtonGroup size="small" color="primary" aria-label="small outlined button group" fullWidth style={{ marginTop: '7px' }}>
                        {props.statusList.map((p) => {
                            return (
                                <Button
                                    variant={state.selectedStatus == p.id ? 'contained' : 'outlined'}
                                    color="primary"
                                    onClick={() => handleInput({ target: { name: 'selectedStatus', value: p.id } })}
                                >
                                    {p.name}
                                </Button>
                            );
                        })}
                    </ButtonGroup>

                    {/* <FormControl component="fieldset"> */}
                    {/* <Grid item xs={12}></Grid> */}
                </Grid>

                <Grid item xs={12}>
                    {state.selectedStatus == 2 && (
                        <ArrivalDateModal
                            partStatusList={props.partStatusList}
                            onClose={props.onClose}
                            headerRecordID={props.headerRecordID}
                            selectedStatus={state.selectedStatus}
                            smsText={state.smsText}
                            sendSMSUpdates={state.sendSMSUpdate}
                            tCardID={props.tCardID}
                            statusList={statusList}
                        />
                    )}
                    {/* {state.selectedStatus == 16 ||
                        (true && (
                            <RebookingRequiredModal
                                partStatusList={props.partStatusList}
                                onClose={props.onClose}
                                headerRecordID={props.headerRecordID}
                                selectedStatus={state.selectedStatus}
                                smsText={state.smsText}
                                sendSMSUpdates={state.sendSMSUpdate}
                            />
                        ))} */}
                    {state.selectedStatus !== 2 && (
                        //Other status
                        <OtherStatusModal
                            partStatusList={state.selectedStatus}
                            onClose={props.onClose}
                            headerRecordID={props.headerRecordID}
                            selectedStatus={state.selectedStatus}
                            smsText={state.smsText}
                            sendSMSUpdates={state.sendSMSUpdate}
                            bookingDate={props.bookingDate}
                            statusList={statusList}
                            tCardID={props.tCardID}
                        />
                    )}
                    {/* {state.selectedStatus == 2 ||
                        (true && (
                            <CommonStatusModal
                                btnTitle={'Cancel Booking'}
                                headerRecordID={props.headerRecordID}
                                onClose={props.onClose}
                                selectedStatus={state.selectedStatus}
                                smsText={state.smsText}
                                sendSMSUpdates={state.sendSMSUpdate}
                            />
                        ))} */}
                </Grid>
            </Grid>
        </div>
    );
};

export default BookedStatusModal;
